import React, { useState } from 'react';
import './RejuvenateServices.css';
import facialimage from '../assets/service-facial.png';
import I from '../assets/I.jpg';
import B from '../assets/B.jpg';
import H from '../assets/H.jpg';
import H1 from '../assets/service-hair.png';
import B1 from '../assets/service-biostimulators.png'

const CLINIC_PHONE = "447802484141"; // WhatsApp number in international format without +

const categoriesData = [
  {
    id: 'skin-facial',
    badge: 'CLARITY, TEXTURE & GLOW',
    title: 'Skin & Facial Treatments',
    description: 'Advanced facials and skin treatments to revitalise, hydrate and restore a radiant, healthy glow.',
    image: facialimage,
    treatments: [
      { name: 'Microneedling', price: '£80', desc: 'Stimulates collagen & elastin for smoother, firmer skin texture.' },
      { name: 'Chemical Peels', price: '£55', desc: 'Exfoliates, improves skin texture, reduces acne and signs of ageing.' },
      { name: 'Bio Peel', price: '£70', desc: 'Advanced medi-peel for clearer, brighter skin rejuvenation.' },
      { name: 'Hydrofacial', price: '£75', desc: '9-stage deep cleanse, extraction & deep hydration facial.' },
      { name: 'Dermaplaning', price: '£40', desc: 'Gently removes dead skin cells and fine peach fuzz.' },
      { name: 'RF Skin Tightening', price: '£75', desc: 'Uses radiofrequency to lift, firm, and boost collagen.' },
      { name: 'PRP Vampire Facial', price: '£150', desc: 'Natural skin regeneration using nutrient-rich plasma.' },
      { name: 'Skin Boosters', price: '£100', desc: 'Deep hydration and natural radiance from within.' },
      { name: 'Lymphatic Drainage + Osteo + Blepharo', price: '£75', desc: 'Bespoke facial drainage, sculpting & eye lift combo.' }
    ]
  },
 {
    id: 'hifu-lift',
    badge: 'LIFT WITHOUT DOWNTIME',
    title: 'HIFU Non-Surgical Lift',
    description: 'Non-invasive ultrasound lifting that tightens skin and stimulates collagen for targeted results.',
    image: H,
    treatments: [
      { name: 'HIFU - Face', price: '£150', desc: 'Non-surgical lift for full facial contours.' },
      { name: 'HIFU - Neck', price: '£120', desc: 'Targets double chin & skin tightening around neck.' },
      { name: 'HIFU - Face & Neck', price: '£199', desc: 'Complete lifting combo for facial and neck area.' },
      { name: 'HIFU - Stomach', price: '£180', desc: 'Tightens loose abdominal skin.' },
      { name: 'HIFU - Arms', price: '£150', desc: 'Targets upper arm skin firmness.' },
      { name: 'HIFU - Inner Thighs', price: '£180', desc: 'Firms and smoothes inner thigh area.' },
      { name: 'HIFU - Back of Thighs', price: '£180', desc: 'Tightens skin on back of legs.' },
      { name: 'HIFU - Bum', price: '£200', desc: 'Lifts & firms buttocks area.' },
      { name: 'Package 1 - Face, Neck & Stomach', price: '£300', desc: 'Full face, neck & abdomen tightening combo (Save £150).' },
      { name: 'Package 2 - Arms & Thighs', price: '£280', desc: 'Upper arms & choice of inner or back of thighs (Save £50).' }
    ]
  },
  {
    id: 'body-contouring',
    badge: 'SCULPT & DEFINE',
    title: 'Body Contouring',
    description: 'Target stubborn fat, tighten skin and sculpt your body naturally with proven technologies.',
    image: B,
    treatments: [
      { name: 'RF Skin Tightening', price: 'From £70', desc: 'Stimulates collagen & firms sagging body skin.' },
      { name: '4D Lipo Cavitation', price: 'From £70', desc: 'Ultrasonic technology breaks down fat cells.' },
      { name: 'Brazilian Bum Lift', price: '£80', desc: 'Vacuum therapy to enhance, lift, and shape.' },
      { name: 'Lemon Bottle Dissolving', price: 'From £70', desc: 'Fast-acting fat dissolving for targeted areas.' },
      { name: 'Lipo Lap Fat Dissolving', price: 'From £80', desc: 'Advanced solution to eliminate targeted fat.' }
    ]
  },
  {
    id: 'injectables',
    badge: 'REFINED & NATURAL',
    title: 'Injectables',
    description: 'Enhance, rejuvenate and restore volume for subtle, natural and beautiful aesthetic results.',
    image: I,
    treatments: [
      { name: 'Dermal Fillers (1ml)', price: 'From £110', desc: 'Restores volume to lips, cheeks, jawline, and chin.' },
      { name: 'Lumi Pro Skin Booster', price: '£100', desc: 'Hydrating booster for glowing face skin.' },
      { name: 'Seventy Hyal 2000', price: '£110', desc: 'Bio-stimulating skin booster for intense hydration.' },
      { name: 'Profhilo Skin Booster', price: '£195', desc: 'Ultimate hyaluronic acid treatment for firm skin.' },
      { name: 'Profhilo Structura', price: '£275', desc: 'Advanced lipolifting treatment to restore lost facial volume and contours.' },
      { name: 'Aespalla', price: '£250', desc: 'Collagen-stimulating bio-stimulator for long-lasting volume restoration.' },
      { name: 'Polynucleotides', price: 'From £150', desc: 'DNA repair treatment for deep rejuvenation.' },
      { name: 'Vitamin Injections', price: 'From £30', desc: 'Vitamin B12, C, D, and Biotin wellness boosts.' }
    ]
  },
  {
    id: 'hair-restoration',
    badge: 'THICKER, HEALTHIER HAIR',
    title: 'Hair Restoration',
    description: 'Advanced scalp treatments that stimulate growth and strengthen natural hair follicles.',
    image: H1,
    treatments: [
      { name: 'PRP Hair', price: '£150', desc: 'Platelet-rich plasma therapy to stimulate scalp hair follicles.' },
      { name: 'Hair Polynucleotides', price: '£180', desc: 'Cellular regenerative hair treatment for thinning hair.' },
      { name: 'Hair Filler (DR CYJ)', price: '£160', desc: 'Peptide complex injected into scalp to stop hair loss.' }
    ]
  },
  {
    id: 'biostimulators',
    badge: 'COLLAGEN FROM WITHIN',
    title: 'Biostimulators',
    description: 'Boost natural collagen production, improve skin quality and achieve long-lasting firmness.',
    image: B1,
    treatments: [
      { name: 'Sculptra', price: '£300', desc: 'PLLA collagen stimulator for subtle, long-lasting lift.' },
      { name: 'Profhilo Structura', price: '£250', desc: 'Lipolifting biostimulator targeting subcutaneous fat cells.' },
      { name: 'AesPlla', price: '£350', desc: 'Advanced bio-stimulator restoring structural skin volume.' },
      { name: 'Plenhyage Polynucleotides', price: 'From £150', desc: 'High concentration salmon DNA polynucleotide regenerator.' }
    ]
  }
];

export default function ClinicMenu() {
  const [selectedTreatment, setSelectedTreatment] = useState(null);

  const openModal = (treatment) => {
    setSelectedTreatment(treatment);
  };

  const closeModal = () => {
    setSelectedTreatment(null);
  };

  const getWhatsAppLink = (treatmentName, price) => {
    const text = encodeURIComponent(`Hi Rejuvenate Clinic, I would like to enquire about ${treatmentName} (${price}). Could you please share available appointment slots?`);
    return `https://wa.me/${CLINIC_PHONE}?text=${text}`;
  };

  const getGeneralWhatsAppLink = () => {
    const text = encodeURIComponent("Hi Rejuvenate Clinic, I would like to enquire about getting a personalised treatment plan.");
    return `https://wa.me/${CLINIC_PHONE}?text=${text}`;
  };

  return (
    <div className="clinic-container">
      {/* --- HEADER SECTION --- */}
      <header className="clinic-header">
        <div className="header-subtitle-row">
          <span className="header-line"></span>
          <span className="header-subtitle">OUR SERVICES</span>
        </div>
        <h1 className="header-title">
          Premium treatments,<br />
          affordable prices, real results
        </h1>
        <p className="header-description">
          Six specialist categories covering skin, face, body and hair. Not sure where to begin? Your free consultation includes a full skin assessment and an honest recommendation.
        </p>
      </header>

      {/* --- CATEGORIES GRID (3 PER ROW) --- */}
      <div className="categories-grid">
        {categoriesData.map((category) => (
          <div className="category-card" key={category.id}>
            <div className="card-image-wrapper">
              <img src={category.image} alt={category.title} />
              <span className="card-badge">{category.badge}</span>
            </div>
            
            <div className="card-content">
              <h2 className="category-title">{category.title}</h2>
              <p className="category-description">{category.description}</p>
              
              <hr className="divider" />

              {/* Clean Sub-Treatments 2-Column List (No prices shown here) */}
              <div className="treatments-grid">
                {category.treatments.map((treatment, index) => (
                  <div 
                    key={index} 
                    className="treatment-item"
                    onClick={() => openModal(treatment)}
                  >
                    <span className="checkmark">✓</span>
                    <span className="treatment-name">{treatment.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* --- FOOTER BANNER SECTION --- */}
      <footer className="clinic-footer-banner">
        <div className="footer-features-row">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Safe & Effective Treatments</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Natural Looking Results</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Long Lasting Results</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Experienced Practitioners</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Personalised Care</span>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="footer-bottom-row">
          <p className="footer-text">
            Treatment plans are always tailored — no packages you don't need, no pressure to commit.
          </p>
          <a 
            href={getGeneralWhatsAppLink()} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-plan-btn"
          >
            GET A PERSONALISED PLAN
          </a>
        </div>
      </footer>

      {/* --- POP-UP MODAL (Price shown here) --- */}
      {selectedTreatment && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>✕</button>
            
            <span className="modal-subtitle">TREATMENT DETAILS</span>
            
            <div className="modal-header-row">
              <h3 className="modal-title">{selectedTreatment.name}</h3>
              <span className="modal-price">{selectedTreatment.price}</span>
            </div>

            <p className="modal-desc">{selectedTreatment.desc}</p>

            <a 
              href={getWhatsAppLink(selectedTreatment.name, selectedTreatment.price)} 
              target="_blank" 
              rel="noopener noreferrer"
              className="modal-whatsapp-btn"
            >
              Book via WhatsApp ({selectedTreatment.price})
            </a>
          </div>
        </div>
      )}
    </div>
  );
}